import React from 'react';
import '../styles/reasons.css';
import card1 from '../../../../assets/company/aboutus/card1.svg';
import card2 from '../../../../assets/company/aboutus/card2.svg';
import card3 from '../../../../assets/company/aboutus/card3.svg';
import card4 from '../../../../assets/company/aboutus/card4.svg';
// import card5 from '../../../../assets/company/aboutus/card5.svg';
// import card6 from '../../../../assets/company/aboutus/card6.svg';

const Reasons = () => {
    return (
        <section className="reasons-section">
            <h2 className="reasons-title">
                {/* Reasons to select us as your cloud migration <br/>and modernization partner! */}
                Why Choose Synectiks
            </h2>
            <div className="reasons-container">
                <div className="reason-card">
                    <img src={card1} alt="Experience" className="reason-icon" />
                    <h3 className="reason-title">Innovation at the Core</h3>
                    <p className="reason-description">From endpoint protection to cloud hosting, from backup to disaster recovery, Synectiks delivers secure transformation built for modern business resilience.</p>
                </div>
                <div className="reason-card">
                    <img src={card2} alt="Expertise" className="reason-icon" />
                    <h3 className="reason-title">Responsive Team</h3>
                    <p className="reason-description">Efficient, agile, and customer-focused-our experts are always ready to respond with the right strategy, execution, and support.</p>
                </div>
                <div className="reason-card">
                    <img src={card3} alt="Time & Money" className="reason-icon" />
                    <h3 className="reason-title">Trusted Partner</h3>
                    <p className="reason-description">A recognized Microsoft Solutions Partner with proven success across industries, delivering modernization, migration, and AI-enabled productivity securely and cost-effectively.</p>
                </div>
                <div className="reason-card">
                    <img src={card4} alt="Long Term Retention" className="reason-icon" />
                    <h3 className="reason-title">World-Class Support</h3>
                    <p className="reason-description">Backed by our follow-the-sun support model, customers run mission-critical workloads with absolute confidence through 24/7/365 monitoring and rapid response.</p>
                </div>
                {/* <div className="reason-card">
                    <img src={card5} alt="Engagement Model" className="reason-icon" />
                    <h3 className="reason-title">Engagement Model</h3>
                    <p className="reason-description">Our every engagement focused on empowerment – not dependency</p>
                </div>
                <div className="reason-card">
                    <img src={card6} alt="Public Cloud Partnership" className="reason-icon" />
                    <h3 className="reason-title">Public Cloud Partnership</h3>
                    <p className="reason-description">Our advanced partnership with major public cloud providers help you to get support at every stage.</p>
                </div> */}
            </div>
        </section>
    );
};

export default Reasons;
